<template>
    <div class="secondList clearfix inner">        
        <div class="inner kinds-content">
            <div class="kind-list clearfix">
                <div class="kind fl">分类：</div>
                <div class="lists clearfix fl" v-loading="loading">
                    <a v-for="(item,i) in tagLists" :key="i" class="tag" :class="{'active':current==i}" href="Javascript:;" @click="chioceTag(i)">{{item.title}}</a>
                </div>
            </div>
        </div>
        <div class="clearfix" v-loading="loading">
            <router-link class="t-list" :to="`detail/${item.tid}/${item.openId}`" ref="detailBlank" target="_blank" v-for="(item,i) in tableList" :key="i" >
                <!-- <div class="imgWrap" :style="{backgroundImage:'url('+item.thumbs[0]+')'}"> -->
                <div class="imgWrap" :style="{'backgroundImage':`url(${item.thumbs.length!==0?(item.thumbs[0]):require('../../assets/imgs/error.png')})`}">
                    <span class="video" v-if="item.special=='10'">
                        <img src="@/assets/imgs/video.png" alt="">
                    </span>
                </div>
                <div class="titleBox">
                    <p class="title">{{item.subject}}</p>
                    <div class="money clearfix">
                        <span class="num nowrap fl">￥{{item.options==null?'':item.options.trade_price}}</span>
                        <span class="want fr nowrap">{{item.placeName}}</span>
                        <!-- <span class="want fr">{{item.views}}人想要</span> -->
                    </div>
                </div>
                <div class="detailBox clearfix">
                    <div class="left fl">
                        <img :src="item.avatar" class="avatar" alt="">
                    </div>
                    <div class="right fl">
                        <p class="name nowrap">{{item.author}}</p>
                        <!-- <p class="address nowrap">{{item.placeName}}</p> -->
                    </div>
                </div>
            </router-link>
        </div>
        <el-pagination
            background
            v-show="tableList.length>0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @pagination="tableList"
            :page-size="pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            tagLists:[],
            current:0,
            pageSize:5,
            total:100,
            currentPage:1,
            tableList:[],
            loading:true
        }
    },
    mounted() {
        this.getLists(0,1)
    },
    methods:{
        // intoDetail(ev,tid,openid) {
        //     // this.$refs.detailBlank.setAttribute("href",`/detail/${tid}/${openid}`)
        //     this.$router.push({path:`/detail/${tid}/${openid}`})
        //     ev.cancelBubble=true
        // },
        handleSizeChange(val) {
        },
        handleCurrentChange(val){
            this.getLists(this.current,val)
        },
        // 获取列表
        getLists(i,page) {
            axios.get(`${this.$commonIp}/v1/threads?streetId=${localStorage.getItem('hstreetId')}&page=${page}&fid=253&items=${i}`).then((res) => {
                let threadlist = res.data.data.threadlist
                let choicelist = res.data.data.choicelist[0].titlelist
                this.tagLists = choicelist
                this.tableList = threadlist
                this.loading = false
            }).catch((error) => {
                console.log(error)
            })
        },
        // 选择分类
        chioceTag(i) {
            this.current = i
            this.getLists(i,1)
            this.currentPage = 1
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/index.less';
    .secondList{
        padding:0 60px;
        .kinds-content{
            margin-bottom:30px;
            .kind-list{
                padding:32px 0 22px;
                font-size:@ft18;
                border-bottom:1px solid #d8d8d8;
                .lists{
                    max-width:1093px;
                    .tag{
                    color:@fc32;
                    padding:3px 6px;
                    border:1px solid #323232;
                    border-radius:4px;
                    font-size:@ft18;
                    margin:0 8px 10px 0;
                    display: inline-block;
                    float: left;
                    &.active{
                        color:#ff4c45;
                        border-color:#ff4c45;
                    }
                    }
                }
                .kind{
                    font-weight: 550;
                    color:#323232;
                    margin-right:10px;
                }
            }
        }
        .t-list{
            width: 19.2%;
            border:1px solid #d8d8d8;
            border-radius:3px;
            overflow: hidden;
            float: left;
            color:#323232;
            background: white;
            cursor: pointer;
            margin-right:1%;
            margin-bottom:20px;
            .imgWrap{
                position: relative;
                width: 100%;
                height:224px;
                overflow: hidden;
                background-size:cover;
                .video{
                    position: absolute;
                    width: 70px;
                    height: 70px;
                    top:50%;
                    margin-top:-35px;
                    left:50%;
                    margin-left:-35px;
                    img{
                        max-width:70px;
                        max-height: 70px;
                    }
                }
                .topImg{
                    width: 100%;
                    height:224px;
                    display: inline-block;
                    &:hover{
                        transform: scale(1.2);
                    }
                }
            }
            .titleBox{
                padding:0 10px;
                .title{
                    -webkit-line-clamp:2;
                    overflow: hidden;
                    word-break: break-all;
                    height: 50px;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    line-height: 24px;
                    font-size:@ft18;
                    margin-top:8px;
                    &:hover{
                        color:#ff4c45;
                    }
                }
                .money{
                    padding-bottom:14px;
                    border-bottom:1px solid #d8d8d8;
                    .num{
                        font-size:@ft22;
                        color:#ff4c45;
                        font-weight: 400;
                        max-width: 110px;
                    }
                    .want{
                        font-size:@ft12;
                        color:#989898;
                        margin-top:7px;
                        display: inline-block;
                        max-width: 90px;
                    }
                }
            }
            &:nth-child(5n) {
                margin-right:0;
            }
            .detailBox{
                padding:14px 10px;
                .left{
                    margin:6px 10px 0 0;
                    .avatar{
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                    }
                }
                .right{
                    font-size:@ft18;
                    max-width: 150px;
                    .name{
                        margin-top:10px;
                    }
                    .address{
                        color:#989898;
                        height:22px;
                        font-size:@ft16;
                        padding-left:20px;
                        background:url(../../assets/imgs/wz.png) no-repeat left center;
                        background-size:14px 18px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/secondlists.vue